import { cn } from '@/lib/utils'
import * as React from 'react'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
}

const Card = React.forwardRef<HTMLDivElement, IProps>(
    ({ children, className, ...rest }, ref) => (
        <div
            ref={ref}
            className={cn(`dark:bg-card rounded-lg shadow-md p-4`, className)}
            {...rest}
        >
            {children}
        </div>
    ),
)

Card.displayName = 'Card'

export default Card
